// extracted by mini-css-extract-plugin
export var bgWhite = "s-module--bgWhite--1220a";
export var content = "s-module--content--4e903";
export var fitHeight = "s-module--fitHeight--f4cca";
export var image = "s-module--image--b84a6";
export var labels = "s-module--labels--3c4b4";
export var newsItemCard = "s-module--newsItemCard--7f9d3";
export var newsItemCardWrapper = "s-module--newsItemCardWrapper--38730";
export var newspaperName = "s-module--newspaperName--750d7";
export var publishedDate = "s-module--publishedDate--1e6a6";
export var referral = "s-module--referral--85948";
export var related3cards = "s-module--related3cards--c39e8";
export var related4cards = "s-module--related4cards--1b872";
export var summaryEllipses = "s-module--summaryEllipses--8e580";
export var title = "s-module--title--21326";